import { Component, OnInit, ChangeDetectorRef,ElementRef, ViewChild, Input  } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import {DialogService}  from 'primeng/dynamicdialog'
import { AlertsService, WorktypeService } from 'src/app/services';
import { UserIdResults, AlertResults } from 'src/app/models';
import { LazyLoadEvent } from 'primeng/api/public_api';
@Component({
  selector: 'bart-dash-alert',
  templateUrl: './dash-alert.component.html',
  styleUrls: ['./dash-alert.component.scss'],
  providers: [DialogService]
})
export class DashAlertComponent implements OnInit {
  @Input() userId: number;
  @Input() bartRoleId: string;
  @Input() userAssignedFacilityNumbers: string;
  @ViewChild('txtRGA', {static: false}) txtRGANumber: ElementRef;
  @Input() boxHeight: number;
  
  //Table Binding source

  public userIdResults: UserIdResults[];
  public abbrevaitionGroupTab:AlertResults[];
  public response: any[];
  loading = false;

  //RGA Popup 
  displayRGANumber:boolean=false;
  rgaContent:string="";
  rgaAlertId:number=0;
  anchors: any;
  constructor
  (
    private changeDetectorRef: ChangeDetectorRef, 
    private activatedRoute: ActivatedRoute,
    private alertService: AlertsService,
    private elementRef:ElementRef,
    public dialogService: DialogService,
    private workType: WorktypeService,
    private router: Router 
    ) {}
  ngOnInit() {

    this.getAlertsByUserId();
    
  }

  public getAlertsByUserId() {
    
       let GETUSERDETAIL=
        {
          USERID: this.userId
        }
      let GETUSERLOCATIONS2=
        {  
          ROLE_ID : this.bartRoleId,
          LOCATIONDATA:this.userAssignedFacilityNumbers
        }

        var request = JSON.stringify({GETUSERDETAIL, GETUSERLOCATIONS2});
        
      
     this.userIdResults=[];
     this.abbrevaitionGroupTab=[];

    if (request != null) {
      this.loading = true;
      this.alertService.getAlertsByUserId(request)
      .subscribe((allAlertResponse: Array<any>) => {
        try
        {
          this.userIdResults = allAlertResponse['userIdResults'];
          this.abbrevaitionGroupTab=allAlertResponse['alertResults'];
          if(this.abbrevaitionGroupTab.length){
            this.abbrevaitionGroupTab.sort(function(a, b) { return -a.AlertGroupDisplaySortOrder; })
          }
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          this.attachClickEventforOpenTicketSummary()
        }
        catch(ex)
        {
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
             this.changeDetectorRef.detectChanges();
          }
        }
        }, 
        (error) => {
          this.userIdResults = [];
          this.abbrevaitionGroupTab=[];
          this.loading = false;
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
          // handle error here
        }
      );
    }

  }
  
  public getAlertGroupCount(abbreviation:string)
  {
     return this.userIdResults.filter(x=>x.AlertGroupAbbreviation==abbreviation).length;
     
  }
  public getAlertGroupNameWithCount(abbreviation:string)
  {
     let tabName=abbreviation +" "+this.userIdResults.filter(x=>x.AlertGroupAbbreviation==abbreviation).length +" ";
     return  tabName;
  }
  public getAlertGroup(abbreviation:string)
  {
    return this.userIdResults.filter(x=>x.AlertGroupAbbreviation==abbreviation)
  }
  public getAlertGroupDetails(alertDetails:UserIdResults)
  {
    let abbreviation:string="";
    let ticketId = "0";
    let ticketNumberStr = "";
    let colAlertDetail="";
    if(alertDetails!=null && alertDetails.AlertID!=null)
    {
      abbreviation = alertDetails.AlertGroupAbbreviation.toLowerCase();
      let ticketNumberRE = /(\d+\-\d+\-\d+)/;
       colAlertDetail = alertDetails.AlertDetail;
      var alertId = alertDetails.AlertID
      var alertTypeCode = alertDetails.AlertTypeCode;
      //check to see if 'alertDetail' has a ticket number
      let containsTicket = ticketNumberRE.test(colAlertDetail);
      if(containsTicket)
      {
        //get ticket number : FORMAT [date]-[facilityId]-[ticketId]
        let ticketNumber = colAlertDetail.match(ticketNumberRE);
        //get ticketId
        let tParams = ticketNumber[0].split("-");
        ticketId = tParams[2];
        ticketNumberStr = ticketNumber[0];
        let linkText = "<a class='ticketSM' role='button' id='"+ticketId+"'>"+ticketNumberStr+"</a>";
        colAlertDetail = colAlertDetail.replace(/\"/g,'&quot;');
        colAlertDetail = colAlertDetail.replace(ticketNumberStr,linkText);
      }
  
  }
    return colAlertDetail
  }
  
  public openRgaNumberPopup(alertId:number,alertDetails:string)
  {
    this.rgaContent="";
    this.rgaAlertId=0;
    this.rgaAlertId=alertId
    
    // let linkText = "<a class='ticketSM' role='button' id='"+ticketId+"'>"+ticketNumberStr+"</a>";
    // alertDetails = alertDetails.replace(alertDetails,linkText);
    let abbreviation:string="";
    let ticketId = "0";
    let ticketNumberStr = "";
    let colAlertDetail="";

    if(alertDetails!=null && alertId!=null)
    {
      abbreviation = alertDetails
      let ticketNumberRE = /(\d+\-\d+\-\d+)/;
       colAlertDetail = alertDetails;
      var alertId = alertId;
      //check to see if 'alertDetail' has a ticket number
      let containsTicket = ticketNumberRE.test(colAlertDetail);
      if(containsTicket)
      {
        //get ticket number : FORMAT [date]-[facilityId]-[ticketId]
        let ticketNumber = colAlertDetail.match(ticketNumberRE);
        //get ticketId
        let tParams = ticketNumber[0].split("-");
        ticketId = tParams[2];
        ticketNumberStr = ticketNumber[0];
        let linkText = "<a class='ticketSM' href='/tickets/"+ticketId+"' role='button' id='"+ticketId+"'>"+ticketNumberStr+"</a>";
        colAlertDetail = colAlertDetail.replace(/\"/g,'&quot;');
        colAlertDetail = colAlertDetail.replace(ticketNumberStr,linkText);
      }
    }

      this.rgaContent=colAlertDetail;


    //this.rgaContent=alertDetails
    this.displayRGANumber=true;
    this.txtRGANumber.nativeElement.value="";
  }
  public saveRGANumber(rgaNumber:string) {
      this.loading = true;
     let SAVERGANUMBER= 
        {
          ALERTID:this.rgaAlertId,
          RGANUMBER: rgaNumber
        }	

      var request = JSON.stringify({SAVERGANUMBER});

      this.alertService.saveRGANumber(request)
      .subscribe((result:any) => {
          this.loading = false;
          this.displayRGANumber=false;
          //this.userIdResults=this.userIdResults.filter(x=>x.AlertID!=this.rgaAlertId);//Changed By Harikesh on 04-Aug-2020
          this.removeAlert(this.rgaAlertId);
          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        }, 
        (respose: Response) => {
          this.loading = false;
        }
      );
  }
  public removeAlert(alertId:number)
  {
    this.loading = true;
    
    let SETALERTACKNOWLEDGE= 
      {
        ALERTID:alertId,
        USERID: this.userId
        
      }	;

      let SETALERTSTATUS = 
      {  
        ALERTSTATUSCODE : 'Acknowledged',
        ALERTID:alertId,
        USERID: this.userId
      }

     var request = JSON.stringify({SETALERTACKNOWLEDGE,SETALERTSTATUS});


    this.alertService.setAlertAcknowledge(request)
      .subscribe((result:any) => {
        let rStstus = result['updateAlertResults'];
          if(rStstus!=null)
          {
            this.userIdResults=this.userIdResults.filter(x=>x.AlertID!=alertId);
            this.loading = false;
            if (!this.changeDetectorRef['destroyed']) {
              this.changeDetectorRef.detectChanges();
            }
          }
        }, 
        (respose: Response) => {
          this.loading = false;
        }
      );
  }

  public attachClickEventforOpenTicketSummary() {
    // Solution for catching click events on anchors using querySelectorAll:
    this.anchors = this.elementRef.nativeElement.querySelectorAll('a.ticketSM');
    this.anchors.forEach((anchor: HTMLAnchorElement) => {
      anchor.addEventListener('click', this.handleAnchorClick)
    })
  }

  public ngOnDestroy() {
    // Cleanup by removing the event listeners on destroy
    if(this.anchors!=null && this.anchors!=undefined)
    {
    this.anchors.forEach((anchor: HTMLAnchorElement) => {
      anchor.removeEventListener('click', this.handleAnchorClick)
    })
  }
  }
  public handleAnchorClick = (event: Event) => {
    // Prevent opening anchors the default way
    const anchor = event.target as HTMLAnchorElement;
    let ticketId=anchor.id
    this.router.navigate(['/tickets', ticketId]);
  }
  paginate(event) 
  {
    setTimeout(() => {
      this.attachClickEventforOpenTicketSummary();
    }, 200);
  }
}






